import { StrictEqualityComparer } from "../../shared/index.js";
import { BasicEnumerable } from "../BasicEnumerable.js";
export const except = (first, second, comparer = StrictEqualityComparer) => {
    function* iterator() {
        const secondArray = [...second];
        for (const firstItem of first) {
            let exists = false;
            for (let j = 0; j < secondArray.length; j++) {
                const secondItem = secondArray[j];
                if (comparer(firstItem, secondItem) === true) {
                    exists = true;
                    break;
                }
            }
            if (exists === false) {
                yield firstItem;
            }
        }
    }
    return new BasicEnumerable(iterator);
};
